import type { IconProps } from '@/types/general'

export const CaretLeft = (props: IconProps) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="20"
		height="21"
		viewBox="0 0 20 21"
		fill="currentColor"
		className={props.className}
	>
		<path
			d="M14.1503 1.74462C13.9338 1.75108 13.7283 1.84156 13.5774 1.9969L5.66073 9.91357C5.50451 10.0699 5.41675 10.2818 5.41675 10.5028C5.41675 10.7237 5.50451 10.9357 5.66073 11.092L13.5774 19.0086C13.6542 19.0886 13.7462 19.1525 13.8479 19.1964C13.9497 19.2404 14.0592 19.2637 14.1701 19.2648C14.281 19.2659 14.3909 19.2449 14.4936 19.203C14.5962 19.1611 14.6895 19.0991 14.7679 19.0207C14.8463 18.9423 14.9083 18.8491 14.9502 18.7464C14.9921 18.6438 15.0131 18.5338 15.012 18.4229C15.0108 18.3121 14.9876 18.2025 14.9436 18.1008C14.8996 17.999 14.8358 17.907 14.7558 17.8302L7.42831 10.5028L14.7558 3.17529C14.8762 3.05824 14.9584 2.90754 14.9917 2.74294C15.025 2.57834 15.0078 2.40752 14.9424 2.25286C14.8769 2.09821 14.7663 1.96693 14.625 1.87624C14.4836 1.78555 14.3182 1.73967 14.1503 1.74462Z"
			fill="currentColor"
		/>
	</svg>
)
